// src/components/AmPhoneInput.tsx
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Input } from 'antd';
import type { InputProps, InputRef } from 'antd';
import { formatAmPhoneMasked } from '../utils/phone';

type Props = Omit<InputProps, 'onChange' | 'value'> & {
  value?: string;
  onChange?: (val: string) => void;
};

const AmPhoneInput: React.FC<Props> = ({ value, onChange, ...rest }) => {
  const [val, setVal] = useState<string>(value ?? '');
  const ref = useRef<InputRef>(null);

  // синхронизация внешнего value → внутренней маски
  useEffect(() => {
    if (value === undefined) return;
    setVal(formatAmPhoneMasked(value));
  }, [value]);

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const masked = formatAmPhoneMasked(e.target.value);
    setVal(masked);
    onChange?.(masked);

    // ставим курсор в конец после маскирования
    requestAnimationFrame(() => {
      try {
        const el = ref.current?.input;
        if (el) {
          const pos = masked.length;
          el.setSelectionRange(pos, pos);
        }
      } catch {
        // no-op
      }
    });
  };

  const placeholder = useMemo(
    () => rest.placeholder ?? '+ (374) XX XX XX XX',
    [rest.placeholder]
  );

  return (
    <Input
      {...rest}
      ref={ref}
      value={val}
      onChange={handleChange}
      inputMode="tel"
      autoComplete="tel"
      maxLength={20}
      placeholder={placeholder}
    />
  );
};

export default AmPhoneInput;
